<fui-date-control [(ngModel)]="value" [placeholder]="placeholder"
                  [label]="label"
                  [attr.id]="elementId"
                  (removed$)="onRemove()"></fui-date-control>
